module.exports = __webpack_public_path__ + "img/mp_list.409660cd.png";